import React from 'react';
import { IconWrapper } from '_common/components/Icon/element';

export default props => <IconWrapper {...props} />;
